import { Typography } from "@mui/material";
import CommunicationSection from "../components/Communications/CommunicationSection";

function Communications() {
  return <CommunicationSection />;
}

export default Communications;
